import { AddIcon } from '@chakra-ui/icons';
import {
    IconButton,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Portal,
    Tooltip,
} from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

const IconComponent = ({ icon }) => {
    const Icon = { icon };
    return <Icon.icon />;
};

const DEFAULT_HOVER_INDEX = -1;

const AddNumbers = ({ menuData: menuItems, setTooltipShow }) => {
    const [hoverItem, setHoverItem] = useState(DEFAULT_HOVER_INDEX);
    const { darkMode } = useSelector((state) => state.settings);

    return (
        <Menu closeOnSelect={false}>
            {({ isOpen }) => {
                if (isOpen) {
                    setTooltipShow.off();
                }
                return (
                    <>
                        <MenuButton
                            as={IconButton}
                            aria-label="Add numbers button"
                            size="sm"
                            padding="6px 12px"
                            leftIcon={<AddIcon />}>
                            Add Numbers
                        </MenuButton>
                        {/* Portalled so the toolbar's overflow:hidden
                            (used for the collapsible button/platform row)
                            can't clip the dropdown. */}
                        <Portal>
                            <MenuList
                                zIndex={1000}
                                bg={darkMode ? 'gray.700' : 'white'}>
                                {menuItems?.map((item, index) => (
                                    <Tooltip
                                        key={`${item.title}-${index}`}
                                        hasArrow
                                        placement="right-end"
                                        label={item?.description}
                                        portalProps={{
                                            containerRef: undefined,
                                        }}
                                        isOpen={hoverItem === index}
                                        shouldWrapChildren>
                                        <MenuItem
                                            onMouseEnter={() =>
                                                setHoverItem(index)
                                            }
                                            onMouseLeave={() =>
                                                setHoverItem(
                                                    DEFAULT_HOVER_INDEX,
                                                )
                                            }
                                            background={
                                                darkMode ? 'gray.700' : 'white'
                                            }
                                            _hover={{
                                                background: darkMode
                                                    ? 'gray.600'
                                                    : 'gray.100',
                                            }}
                                            icon={
                                                <IconComponent
                                                    icon={item?.icon}
                                                />
                                            }
                                            onClick={item?.action}>
                                            <span>{item?.title}</span>
                                        </MenuItem>
                                    </Tooltip>
                                ))}
                            </MenuList>
                        </Portal>
                    </>
                );
            }}
        </Menu>
    );
};

export { AddNumbers };
